import { render } from "./HomeQrTypeDescriptionsList.vue?vue&type=template&id=c29a434c&scoped=true&ts=true&lang=pug"
import script from "./HomeQrTypeDescriptionsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeQrTypeDescriptionsList.vue?vue&type=script&lang=ts&setup=true"

import "./HomeQrTypeDescriptionsList.vue?vue&type=style&index=0&id=c29a434c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29a434c"]])

export default __exports__